<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Search Form
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form @submit.prevent="loadReport">
                  <v-row class="px-2 py-2">
                    <v-col lg="2" md="2" cols="12">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="From Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="filters.from_date"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="2" md="2" cols="12">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="To Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="filters.to_date"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="4" md="4" cols="12">
                      <v-autocomplete
                        v-model="filters.lc_id"
                        :items="lcList"
                        :item-title="item => `${item.lc_no}${item.code ? ' - ' + item.code : ''}`"
                        item-value="id"
                        label="Filter by LC (Optional)"
                        density="compact"
                        prepend-inner-icon="mdi-file-document-outline"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        clearable
                        hide-details
                      ></v-autocomplete>
                    </v-col>

                    <v-col lg="2" md="2" cols="12">
                      <v-btn
                        class="bg-brand w-15"
                        type="submit"
                        :loading="loading"
                        prepend-icon="mdi-magnify"
                        >Search</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid style="margin-top: -20px;">
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel1">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                LC Costing Summary Report
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col md="4" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-col md="5" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                        v-if="reportData.length > 0"
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                          >CSV</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                          >EXCEL</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                          >PDF</v-btn
                        >
                      </v-btn-group>
                    </div>
                  </v-col>

                  <v-col md="3" cols="12">
                    <div class="text-right">
                      <v-chip
                        v-if="reportData.length > 0"
                        color="primary"
                        variant="tonal"
                        size="small"
                      >
                        Total: {{ reportData.length }}
                      </v-chip>
                    </div>
                  </v-col>
                </v-row>

                <!-- Summary Cards -->
                <!-- <v-row v-if="reportData.length > 0" class="mb-4">
                  <v-col cols="12" md="3">
                    <v-card color="primary" variant="tonal">
                      <v-card-text>
                        <div class="text-caption">Total Landed Cost</div>
                        <div class="text-h6 font-weight-bold">{{ formatCurrency(totalSummary.total_landed_cost) }}</div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-card color="success" variant="tonal">
                      <v-card-text>
                        <div class="text-caption">Total Accepted Qty</div>
                        <div class="text-h6 font-weight-bold">{{ formatNumber(totalSummary.total_accepted_qty) }}</div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-card color="info" variant="tonal">
                      <v-card-text>
                        <div class="text-caption">Average Cost Per Unit</div>
                        <div class="text-h6 font-weight-bold">{{ formatCurrency(totalSummary.avg_cost_per_unit) }}</div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-card color="warning" variant="tonal">
                      <v-card-text>
                        <div class="text-caption">Total Records</div>
                        <div class="text-h6 font-weight-bold">{{ reportData.length }}</div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row> -->

                <v-data-table
                  :headers="headers"
                  :items="reportData"
                  :search="search"
                  :loading="loading"
                  item-value="id"
                  class="elevation-1"
                  density="compact"
                >
                  <template v-slot:item.index="{ index }">
                    {{ index + 1 }}
                  </template>

                  <template v-slot:item.lc_no="{ item }">
                    {{ item.lc_master?.lc_no || item.lc_id }}
                  </template>

                  

                  <template v-slot:item.cif_value="{ item }">
                    {{ formatCurrency(item.cif_value) }}
                  </template>

                  <template v-slot:item.freight="{ item }">
                    {{ formatCurrency(item.freight) }}
                  </template>

                  <template v-slot:item.insurance="{ item }">
                    {{ formatCurrency(item.insurance) }}
                  </template>

                  <template v-slot:item.customs_duty="{ item }">
                    {{ formatCurrency(item.customs_duty) }}
                  </template>

                  <template v-slot:item.vat="{ item }">
                    {{ formatCurrency(item.vat) }}
                  </template>

                  <template v-slot:item.total_landed_cost="{ item }">
                    <strong>{{ formatCurrency(item.total_landed_cost) }}</strong>
                  </template>

                  <template v-slot:item.total_accepted_qty="{ item }">
                    {{ formatNumber(item.total_accepted_qty) }}
                  </template>

                  <template v-slot:item.landed_cost_per_unit="{ item }">
                    {{ formatCurrency(item.landed_cost_per_unit) }}
                  </template>

                  <template v-slot:item.status="{ item }">
                    <v-chip
                      :color="item.status === 1 ? 'success' : 'grey'"
                      size="small"
                      variant="tonal"
                    >
                      {{ item.status === 1 ? 'Posted' : 'Draft' }}
                    </v-chip>
                  </template>

                  <template v-slot:item.created_at="{ item }">
                    {{ formatDateView(item.created_at) }}
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      icon="mdi-eye"
                      size="small"
                      variant="text"
                      color="info"
                      @click="viewItem(item.id)"
                    ></v-btn>
                  </template>

                  <template v-slot:no-data>
                    <div class="text-center pa-4">
                      <v-icon size="48" color="grey">mdi-database-search</v-icon>
                      <p class="text-grey mt-2">No costing data found</p>
                      <p class="text-caption text-grey">Click Search to load report data</p>
                    </div>
                  </template>
                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { formatDateView, formatDateDash } from "@/plugins/helpers";
import { ref, computed, onMounted, getCurrentInstance } from "vue";
import { useRouter } from "vue-router";
import { toast } from "vue3-toastify";
import { useStore } from "vuex";
import Axios from "axios";
import { getLcImportCostingSummaryReport } from "@/store/api";
import formattedDate from '@/plugins/dateFormatter';

export default {
  name: "LcImportCostingSummaryReport",
  methods: {
    formatDateView,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const instance = getCurrentInstance();

    const panel = ref([0]);
    const panel1 = ref([0]);
    const loading = ref(false);
    const search = ref("");
    const reportData = ref([]);
    const filters = ref({
      from_date: null,
      to_date: null,
      lc_id: null,
    });

    const headers = [
      { title: "#SL", align: "center", key: "index", width: "5%", sortable: false },
      { title: "LC No", key: "lc_no", align: "left", sortable: true },
     
      { title: "CIF Value", key: "cif_value", align: "right", sortable: true },
      { title: "Freight", key: "freight", align: "right", sortable: true },
      { title: "Insurance", key: "insurance", align: "right", sortable: true },
      { title: "Customs Duty", key: "customs_duty", align: "right", sortable: true },
      { title: "VAT", key: "vat", align: "right", sortable: true },
      { title: "Total Landed Cost", key: "total_landed_cost", align: "right", sortable: true },
      { title: "Total Accepted Qty", key: "total_accepted_qty", align: "right", sortable: true },
      { title: "Cost Per Unit", key: "landed_cost_per_unit", align: "right", sortable: true },
      { title: "Status", key: "status", align: "center", sortable: true },
      { title: "Created Date", key: "created_at", align: "left", sortable: true },
      { title: "Actions", align: "center", key: "actions", sortable: false, width: "10%" },
    ];

    const lcList = computed(() => {
      return store.getters.getLcImportLcMasterList || [];
    });

    const getCurrentCompany = computed(() => {
      return store.getters.getCurrentCompany || {};
    });

    const getFileServerUrl = computed(() => {
      return store.getters.getFileServerUrl || "";
    });

    const totalSummary = computed(() => {
      if (reportData.value.length === 0) {
        return {
          total_landed_cost: 0,
          total_accepted_qty: 0,
          avg_cost_per_unit: 0,
        };
      }

      const totalLandedCost = reportData.value.reduce((sum, item) => {
        return sum + parseFloat(item.total_landed_cost || 0);
      }, 0);

      const totalAcceptedQty = reportData.value.reduce((sum, item) => {
        return sum + parseFloat(item.total_accepted_qty || 0);
      }, 0);

      const avgCostPerUnit = totalAcceptedQty > 0 ? totalLandedCost / totalAcceptedQty : 0;

      return {
        total_landed_cost: totalLandedCost,
        total_accepted_qty: totalAcceptedQty,
        avg_cost_per_unit: avgCostPerUnit,
      };
    });

    const loadReport = async () => {
      try {
        loading.value = true;
        const params = {};
        
        if (filters.value.from_date) {
          params.from_date = formattedDate(filters.value.from_date);
        }
        if (filters.value.to_date) {
          params.to_date = formattedDate(filters.value.to_date);
        }
        if (filters.value.lc_id) {
          params.lc_id = filters.value.lc_id;
        }

        const response = await Axios.get(getLcImportCostingSummaryReport, { params });
        reportData.value = response.data?.data || response.data || [];
        
        if (reportData.value.length === 0) {
          toast.info("No costing data found for the selected criteria");
        } else {
          toast.success(`Loaded ${reportData.value.length} costing record(s)`);
        }
      } catch (error) {
        toast.error(error.response?.data?.message || "Failed to load costing summary report");
        reportData.value = [];
      } finally {
        loading.value = false;
      }
    };

    const formatNumber = (num) => {
      if (!num && num !== 0) return "0.00";
      return Number(num).toFixed(2);
    };

    const formatCurrency = (amount) => {
      if (!amount && amount !== 0) return "0.00";
      return Number(amount).toFixed(2);
    };

    const viewItem = (id) => {
      router.push({ name: "lc-import-lc-costing-view", params: { id } });
    };

    const exportToCSV = () => {
      const items = reportData.value || [];

      if (!items.length) {
        toast.warning("No data to export");
        return;
      }

      const data = [[
        "#SL",
        "LC No",
        "CIF Value",
        "Freight",
        "Insurance",
        "Customs Duty",
        "VAT",
        "Total Landed Cost",
        "Total Accepted Qty",
        "Cost Per Unit",
        "Status",
        "Created Date",
      ]];

      items.forEach((item, index) => {
        data.push([
          index + 1,
          item.lc_master?.lc_no || item.lc_id || "",
          item.cif_value ?? 0,
          item.freight ?? 0,
          item.insurance ?? 0,
          item.customs_duty ?? 0,
          item.vat ?? 0,
          item.total_landed_cost ?? 0,
          item.total_accepted_qty ?? 0,
          item.landed_cost_per_unit ?? 0,
          item.status === 1 ? "Posted" : "Draft",
          formatDateView(item.created_at),
        ]);
      });

      const proxy = instance?.proxy;
      if (proxy?.$exportTableToCSV && proxy?.$fileDate) {
        proxy.$exportTableToCSV(
          data,
          "lc_import_costing_summary_report_" + proxy.$fileDate()
        );
      } else {
        toast.error("CSV export is not configured");
      }
    };

    const exportToExcel = () => {
      const items = reportData.value || [];

      if (!items.length) {
        toast.warning("No data to export");
        return;
      }

      const data = [[
        "#SL",
        "LC No",
        "CIF Value",
        "Freight",
        "Insurance",
        "Customs Duty",
        "VAT",
        "Total Landed Cost",
        "Total Accepted Qty",
        "Cost Per Unit",
        "Status",
        "Created Date",
      ]];

      items.forEach((item, index) => {
        data.push([
          index + 1,
          item.lc_master?.lc_no || item.lc_id || "",
          item.cif_value ?? 0,
          item.freight ?? 0,
          item.insurance ?? 0,
          item.customs_duty ?? 0,
          item.vat ?? 0,
          item.total_landed_cost ?? 0,
          item.total_accepted_qty ?? 0,
          item.landed_cost_per_unit ?? 0,
          item.status === 1 ? "Posted" : "Draft",
          formatDateView(item.created_at),
        ]);
      });

      const proxy = instance?.proxy;
      if (proxy?.$exportTableToExcel && proxy?.$fileDate) {
        proxy.$exportTableToExcel(
          data,
          "lc_import_costing_summary_report_" + proxy.$fileDate()
        );
      } else {
        toast.error("Excel export is not configured");
      }
    };

    const exportToPDF = async () => {
      const items = reportData.value || [];

      if (!items.length) {
        toast.warning("No data to export");
        return;
      }

      const company = getCurrentCompany.value;
      const fileServerUrl = getFileServerUrl.value;

      let printWindow = window.open(
        "",
        "PRINT",
        `width=${screen.width}, height=${screen.height}, left=0, top=0`
      );

      let tableRows = "";

      items.forEach((item, index) => {
        tableRows += `
          <tr>
            <td>${index + 1}</td>
            <td>${item.lc_master?.lc_no || item.lc_id || ""}</td>
            <td class="text-end">${(item.cif_value ?? 0).toLocaleString()}</td>
            <td class="text-end">${(item.freight ?? 0).toLocaleString()}</td>
            <td class="text-end">${(item.insurance ?? 0).toLocaleString()}</td>
            <td class="text-end">${(item.customs_duty ?? 0).toLocaleString()}</td>
            <td class="text-end">${(item.vat ?? 0).toLocaleString()}</td>
            <td class="text-end">${(item.total_landed_cost ?? 0).toLocaleString()}</td>
            <td class="text-end">${(item.total_accepted_qty ?? 0).toLocaleString()}</td>
            <td class="text-end">${(item.landed_cost_per_unit ?? 0).toLocaleString()}</td>
            <td>${item.status === 1 ? "Posted" : "Draft"}</td>
            <td>${formatDateView(item.created_at)}</td>
          </tr>
        `;
      });

      printWindow.document.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <meta http-equiv="X-UA-Compatible" content="ie=edge">
            <title>LC Costing Summary Report</title>
            <link rel="preconnect" href="https://fonts.googleapis.com">
            <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
            <link href="https://fonts.googleapis.com/css2?family=Arimo:ital,wght@0,400..700;1,400..700&display=swap" rel="stylesheet">
            <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.8/dist/css/bootstrap.min.css" rel="stylesheet">
            <link href="https://cdn.jsdelivr.net/npm/@mdi/font@7.4.47/css/materialdesignicons.min.css" rel="stylesheet">
            <style>
              body { font-family: 'Arimo', sans-serif; margin: 0px; }
              .invoice-header { display:flex; justify-content:space-between; align-items:center; border-bottom:2px solid #eee; padding-bottom:10px; }
              .invoice-header img { max-height: 70px; max-width: 150px; }
              .table th, .table td { border: 1px solid #000; padding: 8px; vertical-align: middle; font-size: 12px; }
              .table th { background-color: #f0f0f0; color: #333; }
              .text-end { text-align: right; }
              .text-center { text-align: center; }
              h4 { font-size: 20px; color: #333; }
              p { font-size: 14px; color: #555; margin: 2px 0; }
              strong { font-weight: bold; color: #333; }
              @page { margin: 0.5in; size: letter; }
              .logo-container { display:flex; align-items:center; }
              .logo-container img { margin-left: 10px; }
              .table { width: 100%; border-collapse: collapse; table-layout: auto; }
              thead { display: table-header-group; }
            </style>
          </head>
          <body>
            <div class="container-fluid position-relative">
              <div class="invoice-header">
                <div>
                  <h4 class="text-uppercase">${company?.name || "Company Name"}</h4>
                  <p style="width:65%">${company?.address || ""}</p>
                  <p><i class="mdi mdi-phone-outline"></i> ${company?.mobile || ""}</p>
                  <p><i class="mdi mdi-email-outline"></i> ${company?.email || ""}</p>
                  ${company?.website ? `<p><i class="mdi mdi-web"></i> ${company.website}</p>` : ""}
                </div>
                <div class="logo-container">
                  ${
                    company?.logo_thumb
                      ? `<img src="${fileServerUrl}${company.logo_thumb}" alt="Logo" class="img-fluid">`
                      : ""
                  }
                </div>
              </div>
              <h4 class="text-center my-4"><strong>LC COSTING SUMMARY REPORT</strong></h4>
              <div class="row mb-3">
                <div class="col-sm-8">
                  ${
                    filters.value.from_date && filters.value.to_date
                      ? `<p><strong>Period:</strong> ${formatDateView(
                          filters.value.from_date
                        )} to ${formatDateView(filters.value.to_date)}</p>`
                      : ""
                  }
                  ${
                    filters.value.lc_id
                      ? (() => {
                          const selectedLc = lcList.value.find(
                            (lc) => lc.id === filters.value.lc_id
                          );
                          return selectedLc
                            ? `<p><strong>LC:</strong> ${selectedLc.lc_no || ""}${
                                selectedLc.code ? " - " + selectedLc.code : ""
                              }</p>`
                            : "";
                        })()
                      : ""
                  }
                </div>
                <div class="col-sm-4 text-end">
                  <p><strong>Total Records:</strong> ${items.length}</p>
                  <p><strong>Total Landed Cost:</strong> ${(totalSummary.value.total_landed_cost ?? 0).toLocaleString()}</p>
                  <p><strong>Total Accepted Qty:</strong> ${(totalSummary.value.total_accepted_qty ?? 0).toLocaleString()}</p>
                </div>
              </div>
              <table class="table mt-4">
                <thead>
                  <tr>
                    <th>SN</th>
                    <th>LC No</th>
                    <th class="text-end">CIF Value</th>
                    <th class="text-end">Freight</th>
                    <th class="text-end">Insurance</th>
                    <th class="text-end">Customs Duty</th>
                    <th class="text-end">VAT</th>
                    <th class="text-end">Total Landed Cost</th>
                    <th class="text-end">Total Accepted Qty</th>
                    <th class="text-end">Cost Per Unit</th>
                    <th>Status</th>
                    <th>Created Date</th>
                  </tr>
                </thead>
                <tbody>
                  ${tableRows}
                </tbody>
              </table>
            </div>
          </body>
        </html>
      `);

      printWindow.moveTo(0, 0);
      printWindow.focus();
      await new Promise((resolve) => setTimeout(resolve, 500));
      printWindow.print();
      printWindow.close();
    };

    onMounted(async () => {
      // Load LC list for filter dropdown
      if (store.getters.getLcImportLcMasterList.length === 0) {
        try {
          await store.dispatch("getLcImportLcMasterList");
        } catch (error) {
          console.error("Failed to load LC list:", error);
        }
      }
    });

    return {
      panel,
      panel1,
      loading,
      search,
      reportData,
      filters,
      headers,
      lcList,
      totalSummary,
      loadReport,
      formatNumber,
      formatCurrency,
      viewItem,
      exportToCSV,
      exportToExcel,
      exportToPDF,
    };
  },
};
</script>

<style scoped>
.panel-header {
  font-weight: 600;
}
</style>

